import {useState,useEffect, useContext} from 'react'
import {Helmet} from "react-helmet";
import React, {Component} from "react";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigationMenuToggle from '../../../Components/Navigation/NavigationMenuToggle'
import {Link} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Button from '@mui/material/Button';
import ValidateUser from '../../../Components/UserCredentials/ValidateUser';
import { GeneralFunctionsContext } from '../../../Components/Contexts/GeneralFunctionsContext';
export default function EarningsForListeners () {
    const navigate = useNavigate();
    const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    useEffect(()=>{
        window.scrollTo(0, 0)
    },[])
    return (
        <>
        <ValidateUser/>
        <Helmet>
            <title>Earnings - For Listeners</title>
            <meta property="og:title" content="Earnings - For Fans" />
            <meta name="title" content="Earnings - For Fans"/>
            <meta name="description" content="Earnings - For Fans"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png"/>
        </Helmet>
        
        <>
        <div className='has-hero-banner'>
            
             <div className={offset > 20 ? "navbar active" : "navbar"}>
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=> navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>FOR LISTENERS</p>
                        </div>
                    
                    </div>
                    <div className="rgt">
                        <NavigationMenuToggle/>
                    </div>
                </div>
            </div> 
            
            
            <div className="mycontainer">
                <div className="hero-banner">
                    <div className="background">
                        <img src="/assets/images/geniux-music-banner-desktop-slide-1.jpg?geniuxmusic" className="bg-image"/>
                        <div className="bg-fade"></div>
                    </div>
                    {/* My  path */}
                    {/* {innerWidth>992 &&(
                        <div className="mypath">
                            <div className="wrapper">
                                <div className="lft">
                                    {window.history.length>1?
                                    <Button onClick={()=>navigate(-1)}>
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    :
                                    <Button onClick={()=>navigate(-1)} disabled="true">
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    }
                                </div>
                                <div className="rgt">
                                    <p>
                                        <Link to="/settings" className="active">EARNINGS</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}
                </div>
               
                <div className="wrapper">
                    <br/>
                    <div className="htitle">
                        <div className="lft"><p>Earn by Listening – Designed for Music Fans</p></div>
                    </div>
                    <p>
                       Your love for music can pay off. Not just in enjoyment, but in real earnings. Our platform is built with one goal: to help music fans like you earn money simply by listening to great songs from your favorite artists. 
                       Whether you’re discovering new tracks or enjoying timeless hits, every minute you spend streaming puts money in your pocket.<br/><br/>
                       No complicated sign-ups. No hidden fees. Just an easy, transparent way to get rewarded for doing what you already love—listening to music.
                    </p>
                    <div className="htitle mb-0">
                        <div className="lft"><p>How it works:</p></div>
                    </div>
                    <p className="mt-2">
                        Every time you listen to a track on our platform, you earn. It’s that simple. We believe music fans deserve fair rewards for their time and support, 
                        so we cut out the middlemen and make sure your earnings are clear and direct.
                        <br/><br/>
                        The more you listen, the more you earn—no strings attached, no fine print.
                    </p>
                    <div className="htitle mb-0">
                        <div className="lft"><p>Key Features:</p></div>
                    </div>
                    <div className='feature-list mt-2'>
                        <p>💰 Live Earnings Tracker: Watch your income grow with real-time updates as you listen.</p>
                        <p>📊 Listening Stats: Discover which artists and songs you earn most from, and explore your listening habits..</p>
                        <p>🎧 Stream-Based Rewards: Get paid fairly based on how much music you enjoy.</p>
                        <p>💼 Secure Wallet: Store your earnings safely and withdraw whenever you want.</p>
                        <p>🚀 Discover & Earn: Explore new artists and boost your earnings by streaming fresh tracks.</p>
                    </div>
                    <div className="htitle mb-0 mt-4">
                        <div className="lft"><p>Join today and unlock your earning journey:</p></div>
                    </div>
                    <p className='mt-2'>
                        A small join fee is required to unlock this earning feature in the app. This helps us maintain a fair and secure experience for all users.
                    </p>
                     <div className='feature-list mt-2 mb-4'>
                        <p><b>Amount to pay: R379.00/year</b> <br/>Once paid, your account will remain active for a full year.</p>
                    </div>

                    <Button variant="outlined">Pay now & Join</Button>
                    
                </div>
            </div>
        </div>
        </>

        
        </>
    )
}



